import * as React from 'react';
export default class ColumnGroup extends React.Component {
}
ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;
